import { DeliveryInstructionsButton } from "./DeliveryInstructionsButton";
import { DeliveryInstructionsDrawer } from "./DeliveryInstructionsDrawer";
export { useDeliveryInstructions } from "./useDeliveryInstructions";

export const DeliveryInstructions = {
  Drawer: DeliveryInstructionsDrawer,
  Button: DeliveryInstructionsButton,
};
